import { render, staticRenderFns } from "./LivePayoffDistribution.vue?vue&type=template&id=8b2629c4&"
import script from "./LivePayoffDistribution.vue?vue&type=script&lang=js&"
export * from "./LivePayoffDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports